import React, { useContext } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import ContentfulDataContext from "../context/contentful-data"

const Articles = props => {
  const { allContentfulArticle } = useContext(ContentfulDataContext)

  let tagCloudComp = null
  let articleComps = null

  if (!props.filter) {
    const fontSizes = ["51%", "69%", "87%", "100%", "57%", "75%", "39%"]

    const categories = allContentfulArticle.edges.reduce(
      (acc, { node: { category } }) => {
        if (category && acc.indexOf(category) < 0) {
          acc.push(category)
        }

        return acc
      },
      []
    )

    if (!categories.length) {
      return ""
    }

    const articlesByCategory = allContentfulArticle.edges.reduce(
      (acc, { node }) => {
        if (acc.hasOwnProperty(node.category)) {
          acc[node.category].push(node)
        } else {
          acc[node.category] = [node]
        }

        return acc
      },
      {}
    )

    if (props.tagCloud) {
      tagCloudComp = (
        <aside className="tagcloud">
          {categories.map((cat, i) => {
            const fontSizeInd =
              i > fontSizes.length - 1 ? i % fontSizes.length : i

            return (
              <a
                key={cat}
                className="tag"
                href={`#${cat.toLowerCase()}`}
                style={{ fontSize: `${fontSizes[fontSizeInd]}` }}
              >
                {cat}
              </a>
            )
          })}
        </aside>
      )
    }

    articleComps = (
      <>
        {categories.map(cat => (
          <React.Fragment key={cat}>
            <h2 id={cat.toLowerCase()} className="article-category-header">
              {cat}
            </h2>
            <section className="articles-by-category">
              {articlesByCategory[cat].map(article => (
                <article
                  key={article.slug}
                  className="post post-cover-title post-cover-small"
                >
                  <Link to={`/${article.slug}`} title={article.title}>
                    <Img
                      fluid={article.titleImage ? article.titleImage.fluid : ``}
                      alt={article.title}
                    />
                    <h3>{article.title}</h3>
                  </Link>
                </article>
              ))}
            </section>
          </React.Fragment>
        ))}
      </>
    )
  } else {
    const filters = props.filter.split(" ")

    // Filter articles
    const articles = allContentfulArticle.edges.filter(({ node: article }) => {
      for (const filter of filters) {
        const [fProp, fVal] = filter.split(":")

        if (!article[fProp] || fVal.indexOf(article[fProp]) < 0) {
          return false
        }
      }

      return true
    })

    if (articles.length) {
      articleComps = (
        <section className="articles-by-category">
          {articles.map(({ node: article }) => (
            <article
              key={article.slug}
              className="post post-cover-title post-cover-small"
            >
              <Link to={`/${article.slug}`} title={article.title}>
                <Img
                  fluid={article.titleImage ? article.titleImage.fluid : ``}
                  alt={article.title}
                />
                <h3>{article.title}</h3>
              </Link>
            </article>
          ))}
        </section>
      )
    }
  }

  return (
    <>
      {tagCloudComp}
      {articleComps}
    </>
  )
}

export default Articles
